module.exports = __webpack_public_path__ + "img/11.81d717c7.jpg";